function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledStatisticComponent } from "./statistic-component.scss";
const DEFAULT_STAT_CONTENT = {
    topic: {}
};
const StatisticComponent = ({ statics, advancedStaticsConfig })=>/*#__PURE__*/ _jsxs(StyledStatisticComponent, {
        lineColor: statics === null || statics === void 0 ? void 0 : statics.lineColor,
        lineMargin: advancedStaticsConfig === null || advancedStaticsConfig === void 0 ? void 0 : advancedStaticsConfig.lineMargin,
        className: "statistic-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "vertical-line"
            }),
            /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, DEFAULT_STAT_CONTENT, statics, advancedStaticsConfig))
        ]
    });
export default StatisticComponent;
